import get from "lodash/get";

const getSessionOrder = (program, week, order) => {
  if (!week) return;
  let total = 0;
  const sessionsInPriorWeeks = get(program, "sessions", []).forEach(
    (session) => {
      if (session.week < week) total += 1;
    }
  );
  total += order;
  return total;
};

export default getSessionOrder;
